import React from "react";
import Header from "../../components/Header";
import PendingCooperativeTable from "../../tables/Cooperative/PendingCooperativeTable";
import { ButtonPrimary } from "../../components/Button/index";
import { PRIVILEGES } from "../../utils/privileges";
import { hasPermission } from "../../utils/permissionChecker";
import { useSelector } from "react-redux";
const PendingCooperative = () => {

  const { user } = useSelector((state) => state.auth);
  
  return (
    <div>
      <Header text="Pending Cooperative">
        {hasPermission(user, PRIVILEGES.CREATE_COOPERATIVE) && (
          <ButtonPrimary href={`/create-cooperative`}>
          Create Cooperative
        </ButtonPrimary>
        )}
      </Header>
      
      {/* TABLE SECTION */}
      <section className="mt-8">
        <PendingCooperativeTable />
      </section>
    </div>
  );
};

export default PendingCooperative;
